<!-- =========================================================================================
    File Name: TableMiscellaneous.vue
    Description: Combine filter,sorter, pagination etc.
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vx-card title="Transaction" id="account-manage-buttons">
    <div>
      <div v-if="transactions.length == 0">
        <br />
        <h5>Load data ....</h5>
      </div>
      <vs-table
        v-model="selected"
        stripe
        :data="transactions"
        id="button-with-loading"
        v-else
      >
        <template slot="thead">
          <vs-th sort-key="title">Transaksi</vs-th>
          <vs-th sort-key="title">Unique Code</vs-th>
          <vs-th sort-key="description">Price</vs-th>
          <vs-th sort-key="requirement">Buyer</vs-th>

          <vs-th sort-key="requirement">Status</vs-th>
          <vs-th sort-key="title">Note</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ tr.store_transaction.code }}</vs-td>
            <vs-td>{{ tr.unique_code }}</vs-td>
            <vs-td>{{ tr.store_transaction.price }}</vs-td>

            <vs-td>{{ tr.member.nama_panjang }}</vs-td>

            <vs-td>{{ setStatus(tr.status) }}</vs-td>
            <vs-td> {{ tr.note }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <br />
      <template>
        <vs-pagination :total="20" v-model="page" :max="10"></vs-pagination>
      </template>
    </div>
  </vx-card>
</template>
   

<script>
import axios from '../../../axios110'
import Prism from 'vue-prism-component'
import moment from 'moment'
import router from '../../../router'
export default {
  data() {
    return {
      'selected': [],
      'tableList': [
        'vs-th: Component',
        'vs-tr: Component',
        'vs-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot'
      ],
      'payments': [],
      'transactions': [],
      'colorAlert': 'primary',
      'titleAlert': 'Alert',
      'activeAlert': false,
      'valueInput': '',
      userAuth: this.$store.state.user,
      'deleteId': null,
      popupActive: false,
      popUpData: [],
      uploadResi: false,
      resi_number: '',
      resi_shipment_id: '',
      page: 1,
      limit: 10,
      oldData: [],
      active1: true,
      alert_success: false,
      message_success: '',
      color: 'success'

    }
  },
  watch: {
    page(newValue, oldValue) {
      this.getTransaction()

    },


  },
  mounted() {
    this.popupActive = false
    this.getTransaction()

  },
  methods: {



    changeStatus(status) {
      if (status == 0) {
        return 'New'
      }
      if (status == 1) {
        return 'Waiting'
      }
      if (status == 2) {
        return 'Unverified'
      }
      if (status == 3) {
        return 'Verified'
      }
      if (status == 9) {
        return 'Cancel'
      }

    },
    getTransaction() {
      this.transactions = []

      axios.get(`/ecommerce/web/transaction/byStore/${this.userAuth.company.id}?limit=` + this.limit + '&page=' + this.page, {})
        .then(res => {

          console.log(res)
          this.transactions = res.data




        })
        .catch(error => {
          console.log(error.response)

        })

    },
    setStatus(status) {
      if (status == 0) {
        return 'New'
      }
      if (status == 1) {
        return 'Waiting'
      }
      if (status == 2) {
        return 'Delivered'
      }
      if (status == 3) {
        return 'Confirmed'
      }
      if (status == 9) {
        return 'Cancel'
      }

    },
    checkStore(id) {
      if (this.userAuth.company.id == id) {
        return 1
      }
      else {
        return 0
      }

    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
      }
    },
    limitChar(str) {
      var output = ''
      if (str.length > 100) {
        str = str.substring(0, 100)
        output = str + '...'
      } else {
        output = str
      }
      return output
    },
    deleteAlert(color, id) {
      this.colorAlert = color
      this.deleteId = id
      console.log(`masuk delete${this.deleteId}`)
      this.$vs.dialog({
        color: this.colorAlert,
        title: 'Apa anda yakin?',
        text: 'Setelah dihapus data ini tidak bisa diakses lagi',
        accept: this.deletePaymentAccount
      })
    },


    editPaymentAccount(id) {
      console.log(id)
      this.$router.push(`/paymentAccount/edit/${id}`)
    },
    handleSelected(tr) {
      this.$router.push(`/payment/${tr.id}/applicant`)
    },
    acceptAlert(color, title, message) {

      this.$vs.notify({
        color,
        title,
        text: message
      })

    },

  },
  components: {
    Prism
  }
}
</script>
